import moment from 'moment'

/**
 * Check if the given date is yesterday.
 *
 * @param {Date|string} date
 * @returns {boolean}
 */
export function isYesterday(date) {
    const toCheckDate = moment(date, moment.ISO_8601).startOf('day')
    const now = moment(new Date()).startOf('day')

    return !!(date && toCheckDate.isValid() && now.diff(toCheckDate, 'days', true) === 1)
}
